import { Link } from 'react-router';
import { useLiveQuery } from 'dexie-react-hooks';
import { PageHeader } from '@/components/PageHeader';
import { Button } from '@/components/Button';
import { Card, EstadoVacio } from '@/components/Card';
import { listarCompras } from '@/db/repos/purchases';
import { formatearCentavos } from '@/domain/money';
import { formatearMedio } from '@/domain/dates';

export function PurchasesPage() {
  const compras = useLiveQuery(() => listarCompras(), []);

  return (
    <div className="space-y-5">
      <PageHeader titulo="Compras" descripcion="Tus tickets registrados" />

      <Link to="/compras/nueva">
        <Button tamano="grande">+ Nueva compra</Button>
      </Link>

      {compras === undefined && <p className="text-sm text-texto-suave">Cargando…</p>}

      {compras !== undefined && compras.length === 0 && (
        <EstadoVacio
          titulo="Todavía no hay compras"
          descripcion="Registra tu primer ticket. Puedes capturar varios productos en una sola compra."
        />
      )}

      {compras !== undefined && compras.length > 0 && (
        <ul className="space-y-3">
          {compras.map((compra) => (
            <li key={compra.id}>
              <Card>
                <div className="flex items-baseline justify-between gap-3">
                  <div className="min-w-0">
                    <p className="font-semibold capitalize text-texto">
                      {compra.proveedor ?? 'Sin proveedor'}
                    </p>
                    <p className="text-sm text-texto-suave">{formatearMedio(compra.fecha)}</p>
                  </div>
                  <span className="shrink-0 text-lg font-bold tabular-nums text-texto">
                    {formatearCentavos(compra.totalCentavos)}
                  </span>
                </div>

                <ul className="mt-3 divide-y divide-borde border-t border-borde pt-2 text-sm">
                  {compra.renglones.map((renglon) => (
                    <li key={renglon.id} className="flex justify-between gap-3 py-1.5">
                      <span className="min-w-0 text-texto-suave">
                        {renglon.nombreInsumo}
                        <span className="block text-xs text-texto-tenue">
                          {renglon.cantidadLegible} ·{' '}
                          {formatearCentavos(renglon.costoPorUnidadCaptura)} /{' '}
                          {renglon.unidadCaptura}
                        </span>
                      </span>
                      <span className="shrink-0 tabular-nums text-texto">
                        {formatearCentavos(renglon.costoCentavos)}
                      </span>
                    </li>
                  ))}
                </ul>

                {compra.notas !== null && (
                  <p className="mt-2 text-xs text-texto-tenue">{compra.notas}</p>
                )}
              </Card>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
